import { render } from "./ManageContent.vue?vue&type=template&id=a566ce30&scoped=true"
import script from "./ManageContent.vue?vue&type=script&lang=js"
export * from "./ManageContent.vue?vue&type=script&lang=js"

import "./ManageContent.vue?vue&type=style&index=0&id=a566ce30&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a566ce30"]])

export default __exports__